import { connect } from 'react-redux';

import {
  getLabels,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getUnitsExecutionState,
} from '../../../reducers/analyticsApp';
import LabelsChart from '../../labels/LabelsChart';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const { result } = unitExecute;

  return {
    zoneId: getProjectOriginalZoneId(state),
    userZoneId: getProjectZoneId(state),
    labels: getLabels(state),
    from: result.chart.from,
    to: result.chart.to,
    unitId: unit?.id,
  };
};

export default connect(mapStateToProps)(LabelsChart);
